import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PagesNavbarComponent } from '@pages/common/components';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgbModule, PagesNavbarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'integraciones-centros-koneksi';
}
